import { apiEndPoint } from '../../../services/endpoint';
import { requestDelete, requestGet, requestPost, requestPut } from '../../../services/requests';

export class CommonService {

  constructor(authEndpoint) {
    this.authEndpoint = apiEndPoint;
  }

  mapCategoryDesign = (category) => {
    switch (category.name) {

        case 'Electrician':
            category.icon = 'fa-plug'
            category.backgroundColor = '#3F51B5'
            break;

        case 'Plumber':
            category.icon = 'fa-shower'
            category.backgroundColor = '#F44336'
            break;

        case 'Carpenter':
            category.icon = 'fa-spray-can'
            category.backgroundColor = '#2196F3'
            break;

        case 'Pest Control':
            category.icon = 'fa-plug'
            category.backgroundColor = '#3F51B5'
            break;

        case 'Painting':
            category.icon = 'fa-paint-roller'
            category.backgroundColor = '#00BCD4'
            break;

        case 'Appliance Repair':
            category.icon = 'fa-tv'
            category.backgroundColor = '#4CAF50'
            break;

        case 'Air Conditioner Service and Repair':
            category.icon = 'fa-fan'
            category.backgroundColor = '#FFC107'
            break;

        case 'Men Grooming':
            category.icon = 'fa-male'
            category.backgroundColor = '#FF9800'
            break;

        case 'Women Grooming':
            category.icon = 'fa-female'
            category.backgroundColor = '#FF5722'
            break;

        case 'Transport':
            category.icon = 'fa-truck'
            category.backgroundColor = '#795548'
            break;

        case 'Manpower':
            category.icon = 'fa-people-carry'
            category.backgroundColor = '#607D8B'
            break;

        case 'Cleaning':
            category.icon = 'fa-broom'
            category.backgroundColor = '#9E9E9E'
            break;

        case 'Mobile Phone':
            category.icon = 'fa-mobile'
            category.backgroundColor = '#7d3fb5'
            break;
    
        default:
            category.icon = 'fa-server'
            category.backgroundColor = '#3f51b5'
            break;
    }
  }

  getCategories = () => {
    const url = this.authUrl('/categories/');
      return requestGet(url)
      .then(response => {
        var categoies = response.data || [];
        if(categoies && categoies.length > 0){
          categoies.forEach(category => {
              this.mapCategoryDesign(category);
          });
        }

        return categoies;
      },
        error => {
          console.log('not able to get categories');
      })
  }

  authUrl(append) {
    return apiEndPoint + append;
  }
}
